import { type SidebarDefinition, defineSidebar } from "@/types/sidebar-session";

import { useRightSidebarStore } from "@/stores/right-sidebar-store";

interface TrainingSidebarInput {
  /** False joins the tab to an open sidebar without taking the focus. */
  select: boolean;
}

export const trainingSidebarDefinition: SidebarDefinition<
  TrainingSidebarInput,
  Record<string, never>
> = defineSidebar<TrainingSidebarInput, Record<string, never>>({
  id: "TRAINING",
  label: "Training",
  order: 35,
  isAvailable: (environment) => environment.capabilities.TRAINING === true,
  strategy: {
    planOpen(context, input) {
      return {
        upsert: [context.write(trainingSidebarDefinition, {})],
        ...(input.select ? { select: trainingSidebarDefinition.id } : {}),
      };
    },
  },
});

export function openTrainingSidebar() {
  useRightSidebarStore
    .getState()
    .open(trainingSidebarDefinition, { select: true });
}

export function closeTrainingSidebar() {
  useRightSidebarStore.getState().close(trainingSidebarDefinition.id);
}

/**
 * While the plan has tasks left, the Training tab joins any open sidebar and
 * can't be closed on its own. "Close sidebar" still closes everything.
 */
export function reconcileTrainingSidebarPin(
  openKeys: readonly string[],
  pinned: boolean,
) {
  if (!pinned || openKeys.length === 0) return;
  if (openKeys.includes(trainingSidebarDefinition.id)) return;
  useRightSidebarStore
    .getState()
    .open(trainingSidebarDefinition, { select: false });
}
